var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('table-ag',{attrs:{"rowData":_vm.relations,"columnDefs":_vm.columns,"components":_vm.components,"component-menu":_vm.componentMenu,"actions":true}}),_vm._v(" "),_c('modalShare',{attrs:{"show":_vm.showData,"informe":_vm.infoShare},on:{"showmodalshare":_vm.showModalShare}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdccb3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lideres/Resumen.vue
// module id = 825
// module chunks = 2